/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchtitle2Inputs */

const en_menulunchtitle2 = /** @type {(inputs: Menulunchtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch menu`)
};

const de_menulunchtitle2 = /** @type {(inputs: Menulunchtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü`)
};

/**
* | output |
* | --- |
* | "Lunch menu" |
*
* @param {Menulunchtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchtitle2 = /** @type {((inputs?: Menulunchtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchtitle2(inputs)
	return de_menulunchtitle2(inputs)
});
export { menulunchtitle2 as "menuLunchTitle" }